/* eslint-disable camelcase */
import posthog from 'posthog-js';
import { isMobile } from 'react-device-detect';
import WebViewServices from '../../services/WebViewServices';

const POSTHOG_TOKEN = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;

export const ANALYTICS_EVENTS = {
  OTTV3_REGISTRATION_COMPLETED: 'ottv3_registration_completed',
};

export const isAnalyticsEnabled = () => initialized;

export const initPostHog = () => {
  if (initialized || typeof window === 'undefined') return;

  if (!POSTHOG_TOKEN) {
    // eslint-disable-next-line no-console
    console.warn(
      '[analytics] REACT_APP_POSTHOG_PROJECT_TOKEN not set — PostHog disabled.',
    );
    return;
  }

  posthog.init(POSTHOG_TOKEN, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    loaded: instance => {
      if (process.env.NODE_ENV === 'development') {
        instance.debug();
      }
    },
  });

  initialized = true;
};

export const getPlatform = () => {
  if (WebViewServices.isReactNative()) return 'app';
  return isMobile ? 'mobile browser' : 'desktop browser';
};

const clean = obj =>
  Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== undefined && obj[key] !== null) acc[key] = obj[key];
    return acc;
  }, {});

export const setSuperProperties = ({ platform, whitelabel_domain } = {}) => {
  if (!initialized) return;
  posthog.register(clean({ platform, whitelabel_domain }));
};

export const captureEvent = (event, properties = {}) => {
  if (!initialized) return;
  posthog.capture(event, properties);
};

export const trackOttV3Registration = ({ user, whitelabelClient } = {}) => {
  if (!initialized) return;

  try {
    const email = user?.email || undefined;
    const mobile =
      user?.mobile || user?.phone || user?.phone_number || undefined;
    const name =
      `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || undefined;
    const platform = getPlatform();
    const whitelabelDomain = whitelabelClient?.domain || undefined;

    // platform + whitelabel_domain are super properties → ride on every event.
    setSuperProperties({ platform, whitelabel_domain: whitelabelDomain });

    captureEvent(
      ANALYTICS_EVENTS.OTTV3_REGISTRATION_COMPLETED,
      clean({ email, mobile, name }),
    );
  } catch (error) {
    // Analytics must never break the registration flow.
    console.error('[analytics] trackOttV3Registration failed', error);
  }
};

export { posthog };
export default posthog;
